export default "__VITE_ASSET__Bnbgo0ek__"